export const sharedHashCanvasState: {
  current: HTMLCanvasElement | OffscreenCanvas | null;
} = {
  current: null,
};
